import React from "react";
import { Container } from "react-bootstrap";


import '../Components/landing.css';
import '../theme/index.css';
import { Header, RectangleImageText, SponsorList2026, Applications, Footer } from '../Components/components-index';

export const Landing = () => {
    return (
        <Container fluid className="px-0">
            <Header/>
            <RectangleImageText/>
            <SponsorList2026 />
            <Applications/>
            <Footer/>
        </Container>
    )
};